import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class PermissionSetting {
    list(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(
            `${APIPath.permissionsList}?${params}`,
        )
    }

    create(data) {
        return BaseService.post(`${APIPath.permissionsCreate}`, data)
    }

    update(id, data) {
        return BaseService.put(`${APIPath.permissionsUpdate}/${id}`, data)
    }

    getCompanyPermissions(companyId) {
        return BaseService.get(APIPath.companyMenuPermissionsShow(companyId))
    }

    saveCompanyPermission(companyId, menuId, isEnabled) {
        return BaseService.post(APIPath.companyMenuPermissionSave(companyId, menuId), { IsEnabled: isEnabled })
    }

    toggleCompanyModule(companyId, moduleKey, isEnabled) {
        return BaseService.post(APIPath.companyModuleToggle(companyId, moduleKey), { isEnabled })
    }

    getUserPermissions(userId) {
        return BaseService.get(APIPath.userMenuPermissionsShow(userId))
    }

    saveUserPermission(userId, menuId, isAllowed) {
        return BaseService.post(APIPath.userMenuPermissionSave(userId, menuId), { isAllowed })
    }

    toggleUserModule(userId, moduleKey, isAllowed) {
        return BaseService.post(APIPath.userModuleToggle(userId, moduleKey), { isAllowed })
    }

    delete(id) {
        return BaseService.post(`${APIPath.permissionsUpdate}/${id}/Remove`)
    }

}

const PermissionSettingService = new PermissionSetting()
Object.freeze(PermissionSettingService)
export { PermissionSettingService }